import { FontAwesomeIcon, FontAwesomeLayers } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faArrowDown } from '@fortawesome/pro-solid-svg-icons/faArrowDown';
import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons/faArrowLeft';
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons/faArrowRight';
import { faArrowsAlt } from '@fortawesome/pro-solid-svg-icons/faArrowsAlt';
import { faBars } from '@fortawesome/pro-solid-svg-icons/faBars';
import { faBallotCheck } from '@fortawesome/pro-solid-svg-icons/faBallotCheck';
import { faBell } from '@fortawesome/pro-solid-svg-icons/faBell';
import { faBriefcase } from '@fortawesome/pro-solid-svg-icons/faBriefcase';
import { faCamera } from '@fortawesome/pro-solid-svg-icons/faCamera';
import { faCalendarAlt } from '@fortawesome/pro-solid-svg-icons/faCalendarAlt';
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons/faCaretDown';
import { faCaretUp } from '@fortawesome/pro-solid-svg-icons/faCaretUp';
import { faChartBar } from '@fortawesome/pro-solid-svg-icons/faChartBar';
import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck';
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons/faCheckCircle';
import { faChessRook } from '@fortawesome/pro-solid-svg-icons/faChessRook';
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons/faChevronDown';
import { faChevronLeft } from '@fortawesome/pro-solid-svg-icons/faChevronLeft';
import { faChevronRight } from '@fortawesome/pro-solid-svg-icons/faChevronRight';
import { faChevronUp } from '@fortawesome/pro-solid-svg-icons/faChevronUp';
import { faClipboard } from '@fortawesome/pro-solid-svg-icons/faClipboard';
import { faClock } from '@fortawesome/pro-solid-svg-icons/faClock';
import { faCog } from '@fortawesome/pro-solid-svg-icons/faCog';
import { faCogs } from '@fortawesome/pro-solid-svg-icons/faCogs';
import { faCoins } from '@fortawesome/pro-solid-svg-icons/faCoins';
import { faComment } from '@fortawesome/pro-solid-svg-icons/faComment';
import { faComments } from '@fortawesome/pro-solid-svg-icons/faComments';
import { faDollarSign } from '@fortawesome/pro-solid-svg-icons/faDollarSign';
import { faDonate } from '@fortawesome/pro-solid-svg-icons/faDonate';
import { faDownload } from '@fortawesome/pro-solid-svg-icons/faDownload';
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons/faExclamationCircle';
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons/faExclamationTriangle';
import { faEyeSlash } from '@fortawesome/pro-solid-svg-icons/faEyeSlash';
import { faFileAlt } from '@fortawesome/pro-solid-svg-icons/faFileAlt';
import { faFileSignature } from '@fortawesome/pro-solid-svg-icons/faFileSignature';
import { faFileInvoiceDollar } from '@fortawesome/pro-solid-svg-icons/faFileInvoiceDollar';
import { faFlag } from '@fortawesome/pro-solid-svg-icons/faFlag';
import { faFlagCheckered } from '@fortawesome/pro-solid-svg-icons/faFlagCheckered';
import { faFolders } from '@fortawesome/pro-solid-svg-icons/faFolders';
import { faGlobe } from '@fortawesome/pro-solid-svg-icons/faGlobe';
import { faHandHoldingUsd } from '@fortawesome/pro-solid-svg-icons/faHandHoldingUsd';
import { faHome } from '@fortawesome/pro-solid-svg-icons/faHome';
import { faIdCard } from '@fortawesome/pro-solid-svg-icons/faIdCard';
import { faInfo } from '@fortawesome/pro-solid-svg-icons/faInfo';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle';
import { faLaptop } from '@fortawesome/pro-solid-svg-icons/faLaptop';
import { faLayerGroup } from '@fortawesome/pro-solid-svg-icons/faLayerGroup';
import { faLink } from '@fortawesome/pro-solid-svg-icons/faLink';
import { faList } from '@fortawesome/pro-solid-svg-icons/faList';
import { faMapMarked } from '@fortawesome/pro-solid-svg-icons/faMapMarked';
import { faMap } from '@fortawesome/pro-solid-svg-icons/faMap';
import { faMapMarker } from '@fortawesome/pro-solid-svg-icons/faMapMarker';
import { faMapMarkerAlt } from '@fortawesome/pro-solid-svg-icons/faMapMarkerAlt';
import { faMapPin } from '@fortawesome/pro-solid-svg-icons/faMapPin';
import { faMapSigns } from '@fortawesome/pro-solid-svg-icons/faMapSigns';
import { faMinus } from '@fortawesome/pro-solid-svg-icons/faMinus';
import { faMoneyBill } from '@fortawesome/pro-solid-svg-icons/faMoneyBill';
import { faChartNetwork } from '@fortawesome/pro-solid-svg-icons/faChartNetwork';
import { faPaperPlane } from '@fortawesome/pro-solid-svg-icons/faPaperPlane';
import { faPencil } from '@fortawesome/pro-solid-svg-icons/faPencil';
import { faPencilAlt } from '@fortawesome/pro-solid-svg-icons/faPencilAlt';
import { faPlug } from '@fortawesome/pro-solid-svg-icons/faPlug';
import { faPlus } from '@fortawesome/pro-solid-svg-icons/faPlus';
import { faPlusCircle } from '@fortawesome/pro-solid-svg-icons/faPlusCircle';
import { faPowerOff } from '@fortawesome/pro-solid-svg-icons/faPowerOff';
import { faQuestion } from '@fortawesome/pro-solid-svg-icons/faQuestion';
import { faRedo } from '@fortawesome/pro-solid-svg-icons/faRedo';
import { faSearch } from '@fortawesome/pro-solid-svg-icons/faSearch';
import { faShield } from '@fortawesome/pro-solid-svg-icons/faShield';
import { faShoppingCart } from '@fortawesome/pro-solid-svg-icons/faShoppingCart';
import { faSignOut } from '@fortawesome/pro-solid-svg-icons/faSignOut';
import { faSort } from '@fortawesome/pro-solid-svg-icons/faSort';
import { faSortDown } from '@fortawesome/pro-solid-svg-icons/faSortDown';
import { faSortUp } from '@fortawesome/pro-solid-svg-icons/faSortUp';
import { faSpinner } from '@fortawesome/pro-solid-svg-icons/faSpinner';
import { faStar } from '@fortawesome/pro-solid-svg-icons/faStar';
import { faSuitcase } from '@fortawesome/pro-solid-svg-icons/faSuitcase';
import { faTabletAlt } from '@fortawesome/pro-solid-svg-icons/faTabletAlt';
import { faTimes } from '@fortawesome/pro-solid-svg-icons/faTimes';
import { faTimesCircle } from '@fortawesome/pro-solid-svg-icons/faTimesCircle';
import { faTools } from '@fortawesome/pro-solid-svg-icons/faTools';
import { faTrashAlt } from '@fortawesome/pro-solid-svg-icons/faTrashAlt';
import { faUser } from '@fortawesome/pro-solid-svg-icons/faUser';
import { faUserHardHat } from '@fortawesome/pro-solid-svg-icons/faUserHardHat';
import { faUsers } from '@fortawesome/pro-solid-svg-icons/faUsers';
import { faUserSecret } from '@fortawesome/pro-solid-svg-icons/faUserSecret';
import { faWrench } from '@fortawesome/pro-solid-svg-icons/faWrench';
import { faHistory } from '@fortawesome/pro-solid-svg-icons/faHistory';
import { faArchive } from '@fortawesome/pro-solid-svg-icons/faArchive';
import { faSlidersH } from '@fortawesome/pro-solid-svg-icons/faSlidersH';

import { faCalendar } from '@fortawesome/pro-regular-svg-icons/faCalendar';
import { faCircle } from '@fortawesome/pro-regular-svg-icons/faCircle';
import { faExclamationCircle as faExclamationCircleRegular } from '@fortawesome/pro-regular-svg-icons/faExclamationCircle';
import { faFile as faFileRegular } from '@fortawesome/pro-regular-svg-icons/faFile';
import { faFileAlt as faFileAltRegular } from '@fortawesome/pro-regular-svg-icons/faFileAlt';
import { faSort as faSortRegular } from '@fortawesome/pro-regular-svg-icons/faSort';
import { faFileImage } from '@fortawesome/pro-regular-svg-icons/faFileImage';

import { faFortAwesome } from '@fortawesome/free-brands-svg-icons/faFortAwesome';

import { faTimes as faTimesLight } from '@fortawesome/pro-light-svg-icons/faTimes';

import { faLockOpen } from '@fortawesome/pro-solid-svg-icons/faLockOpen';
import { faLock } from '@fortawesome/pro-solid-svg-icons/faLock';

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('font-awesome-layers', FontAwesomeLayers);

library.add(
    faArrowsAlt,
    faArrowRight,
    faBallotCheck,
    faUser,
    faUserHardHat,
    faUsers,
    faChartBar,
    faLaptop,
    faTabletAlt,
    faHome,
    faPaperPlane,
    faBell,
    faCalendarAlt,
    faCog,
    faCogs,
    faCoins,
    faCheckCircle,
    faTimes,
    faTimesLight,
    faTimesCircle,
    faPencil,
    faPencilAlt,
    faSpinner,
    faChevronDown,
    faChevronRight,
    faChevronLeft,
    faChevronUp,
    faCaretDown,
    faCaretUp,
    faPowerOff,
    faClipboard,
    faClock,
    faSearch,
    faMapPin,
    faMapSigns,
    faChartNetwork,
    faList,
    faCheck,
    faIdCard,
    faExclamationCircle,
    faExclamationCircleRegular,
    faQuestion,
    faComment,
    faComments,
    faMinus,
    faUserSecret,
    faSignOut,
    faSort,
    faSortUp,
    faSortDown,
    faMapMarked,
    faMapMarkerAlt,
    faCamera,
    faShield,
    faPlug,
    faPlus,
    faPlusCircle,
    faDownload,
    faEyeSlash,
    faArrowLeft,
    faArrowDown,
    faRedo,
    faChessRook,
    faMapMarker,
    faDollarSign,
    faGlobe,
    faBars,
    faShoppingCart,
    faFileAlt,
    faFileImage,
    faFileAltRegular,
    faFileInvoiceDollar,
    faFileRegular,
    faFileSignature,
    faFlag,
    faWrench,
    faSuitcase,
    faInfo,
    faInfoCircle,
    faHandHoldingUsd,
    faMoneyBill,
    faDonate,
    faExclamationTriangle,
    faBriefcase,
    faStar,
    faCircle,
    faCalendar,
    faFortAwesome,
    faSortRegular,
    faTrashAlt,
    faTools,
    faLink,
    faFlagCheckered,
    faLayerGroup,
    faFolders,
    faMap,
    faHistory,
    faArchive,
    faSlidersH,
    faLockOpen,
    faLock,
);
